import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import "./styles/klaus-gridski.css"

//  VERTICAL CARD (Gernerell)
const CardStyle = styled.div`
  background: var(--background);
  width: 100%;
  max-width: 340px;
  padding: 2rem;
  margin: 2rem 0;
`
const Headline = styled.h4`
  font-size: 2rem;
  font-style: italic;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 2rem;
`

const ImgStyle = styled.img`
  object-fit: cover;
  position: center center;
  max-height: 170px;
  width: 100%;
  margin-bottom: 1rem;
`

const ButtonStyle = styled.button`
  background: black;
  color: white;
  border: none;
  padding: 7px 10px;
  font-weight: 800;
  font-size: 1.4rem;
  margin-top: 1.5rem;
  transition: ease-in-out 0.2s;
  :hover {
    background: var(--red);
  }
`
// HORIZONTAL CARD
const HorizontalCardStyle = styled.div`
  background: var(--background);
  width: 100%;
  padding: 2rem;
  margin: 2rem 0;
  img {
    max-width: 280px;
  }
`

const CardContent = styled.div`
  max-width: 400px;
  /* ==== = MEDIUM = ==== */
  @media only screen and (min-width: 48em) {
    margin-left: 2rem;
  }
`

export const VerticalCard = ({
  children,
  img,
  headline,
  buttonText,
  buttonLink,
}) => {
  return (
    <CardStyle>
      <Headline>{headline}</Headline>
      <ImgStyle src={img} />
      <p>{children}</p>
      <ButtonStyle>
        <Link to={buttonLink}>{buttonText}</Link>
      </ButtonStyle>
    </CardStyle>
  )
}

export const HorizontalCard = ({
  children,
  img,
  headline,
  buttonText,
  buttonLink,
}) => {
  return (
    <HorizontalCardStyle>
      <Headline>{headline}</Headline>
      <div className="flex vertical md-horizontal">
        <ImgStyle alt="Webcam Livebild" src={img} />
        <CardContent>
          <p>{children}</p>
          <ButtonStyle>
            <Link to={buttonLink}>{buttonText}</Link>
          </ButtonStyle>
        </CardContent>
      </div>
    </HorizontalCardStyle>
  )
}
